import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useContextMenu} from "components/dropdowns/useContextMenu.js"
import ContextMenu from "components/dropdowns/ContextMenu.js"
import MenuItem from "components/dropdowns/MenuItem.js";
import {zmessageUpdated} from 'zobject/subpatch/operations.js';
import {useDoubleClick} from "components/hooks/useDoubleClick.js";
import {connect} from 'react-redux';

const SubPatchInlet = ({zmessage, field="inletNumber", icon="inlet-icon"}) => { 
    let ref = useRef(undefined);
    let inletRef = useRef(undefined);

    const {onContextMenu, dropdownPos, setDropdownPos} = useContextMenu({ref: inletRef});
    let [text, setText] = useState('');
    let [editing, setEditing] = useState(false);
    const onDoubleClick = useDoubleClick(() => setEditing(true));

    useEffect(() => {
        if (ref.current && editing) {
            ref.current.focus();
        }
    }, [editing]);

    const keyDown = useCallback((e) => {
        if (e.key === "Enter") {
            zmessage._text = text;
            zmessage.subSequence.propagate(zmessageUpdated(zmessage, text));
            setEditing(false);
        }
    }, [setEditing, text]);

    let className = "io-inner ";
    let isInstance = false;
    if (zmessage.subSequence.instanceInlets && zmessage.subSequence.instanceInlets.includes(zmessage)) {
        className += " instance-inlet";
        let isInstance = true;
    }

    const convertInlet = useCallback(() => {
        let subpatch = zmessage.subSequence;
        // this needs to be propagated
        subpatch.toggleInlet(zmessage);
    }, [isInstance, zmessage]);

    return (
        <div
          ref={inletRef}
          onContextMenu={field==="inletNumber" ? onContextMenu : () => []}
          className={className} onClick={onDoubleClick}>
          <ContextMenu dropdownPos={dropdownPos} setDropdownPos={setDropdownPos}>
            <MenuItem onClick={convertInlet}>
              {isInstance ? "Convert to Shared Inlet" : "Convert to Instance Inlet"}
            </MenuItem>
          </ContextMenu>
          {editing ?
           <div className="io-number">
             <input
               onKeyDown={keyDown}
               ref={ref} value={text} type="text" onChange={(e) => setText(e.target.value)}/>
           </div> : 
           <div className="io-number">
             {zmessage[field]} {zmessage._text !== '' ? ". " + zmessage._text : ""}
           </div>}
          <div className={icon}/> 
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      ioNumber: props.zmessage[props.field]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubPatchInlet);
